import { handleStateChange } from '@hotjar/webapp/domains/common/tracking/contentSquare';

/**
 * Contentsqaure related tracking.
 */
angular.module('hjApp.tracking').service('Contentsquare', function ($rootScope, Feature) {
    const isEnabled = Feature.isAllowed('contentsquare_ux_analytics');

    function onStateChange() {
        if (isEnabled) {
            handleStateChange();
        }
    }

    // /*************************
    //  * INITIALIZATION
    //  *************************/
    $rootScope.$on('$stateChangeSuccess', onStateChange);
});
